import React from 'react';
import './App.css';
import CssBaseline from '@mui/material/CssBaseline';
import route from 'router';
import { Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import theme from './theme/themes';
import storeRedux from 'store';
import { I18n } from 'utilities/utilities';
import AuthSession from 'AuthSession';
import Template from "components/DialogAlert/STcustom/STcustomTemplate";
import CookieConsentProvider from 'view/Cookie/CookieConsentProvider';
import { useSelector } from "react-redux";
import { ThemeProvider, Backdrop } from '@mui/material';

const store = storeRedux();
I18n.InitialI18next();

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Template />
        <AuthSession />
        <Routes>
          {route.map((o) => {
            return (
              <Route
                path={o.path}
                key={o.path}
                element={
                  o.layout ? (<o.layout><o.component /></o.layout>) : (<o.component />)
                }
              />
            );
          })}
        </Routes>
        <BackdropBlockUI/>
      </ThemeProvider>
      <CookieConsentProvider />
    </Provider>
  );
};
export default App;

export const BackdropBlockUI = () => {
  const isOpent = useSelector((state: any) => state.blockuiReducer?.IsOpen?state.blockuiReducer?.IsOpen:false);
  return (
      <Backdrop
          sx={{
              zIndex: 10000,
              backgroundColor: "rgba(0, 0, 0, 0.21)",
          }}
          open={isOpent}
          key={"Backdrop"}
          id="Backdrop"
      >
          <div id="page">
              <div id="container">
                  <div id="ring"></div>
                  <div id="ring"></div>
                  <div id="ring"></div>
                  <div id="ring"></div>
                  <div id="h3">กำลังโหลด</div>
              </div>
          </div>
      </Backdrop>
  )
}

